'use client';

let previousPathname: string | null = null;
let lastReferrerPathname = '';
let previousVirtualPageURL: string | null = null;
const firedPageViewEvents = new Map<string, Set<string>>();

export function shouldSendGtmPageView(pathname: string, event: string): boolean {
  let events = firedPageViewEvents.get(pathname);
  if (!events) {
    events = new Set();
    firedPageViewEvents.set(pathname, events);
  }
  if (events.has(event)) return false;
  events.add(event);
  return true;
}

export const buildGtmPageUrl = (
  pathname: string,
  options?: { includeSearch?: boolean }
): string => {
  if (typeof window === 'undefined') return pathname;
  const search = options?.includeSearch === false ? '' : window.location.search;
  return `${window.location.origin}${pathname}${search}`;
};

export type GtmNavigationSnapshot = {
  virtualPageURL: string;
  virtualPageReferrer: string | null;
  isFirstNavigation: boolean;
};

export function recordGtmNavigation(pathname: string): GtmNavigationSnapshot {
  const virtualPageURL = buildGtmPageUrl(pathname);
  const isFirstNavigation = previousVirtualPageURL === null;
  const virtualPageReferrer = isFirstNavigation ? null : previousVirtualPageURL;

  if (previousPathname !== null && previousPathname !== pathname) {
    lastReferrerPathname = previousPathname;
    firedPageViewEvents.delete(previousPathname);
  }

  previousPathname = pathname;
  previousVirtualPageURL = virtualPageURL;

  return { virtualPageURL, virtualPageReferrer, isFirstNavigation };
}

export function getGtmReferrerUrl(): string {
  if (lastReferrerPathname) {
    return buildGtmPageUrl(lastReferrerPathname, { includeSearch: false });
  }

  if (typeof document === 'undefined' || !document.referrer) return '';

  return document.referrer;
}
